import { useTranslation } from '@klv/hooks/useTranslation';
import Typography from '@klv/atoms/typography';
import { MfaSupportFields } from '@klv/organisms/form-account-access/fields/supportFormFields';

import * as s from '@klv/organisms/form-account-access/styles';

import type { ISupportFormFieldContainer } from '@klv/organisms/form-account-access/types';

export const MfaSupportFieldsContainer = ({
  backgroundColor,
}: ISupportFormFieldContainer) => {
  const { t } = useTranslation();

  return (
    <div>
      <s.MfaSupportFieldsInfo>
        <Typography colorVariant='dark' forwardedAs='p' variant='paragraph1'>
          {t(
            'organisms_forms_accountAccessForm_form_mfa_support_extra_fields_info',
          )}
        </Typography>
      </s.MfaSupportFieldsInfo>
      <MfaSupportFields backgroundColor={backgroundColor} />
    </div>
  );
};
